import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './Container.less';
import BaseContainer from '../components/BaseContainer';
import Header from '../components/HeaderForPC';
import Footer from '../components/FooterForPC';
import useAreaLimit from '~/common/hooks/useAreaLimit';
import DomainLimit from '~/components/domainLimit';
import Device from '~/components/device';
import { stepsData } from '~/components/device/utils';
import { stepsDetail } from '../components/device/utils';
import { deviceTransformMap, textTransformMap } from './utils';
import { getSpecFont, getSpecLine } from '../utils/fontClass/index';

export default function Container() {
  const { t, i18n } = useTranslation();
  const [auto, setAuto] = useState(true);
  const [step, setStep] = useState(0); // 0,未开始，开始阶段1 ~ 11
  const autoRef = useRef(auto);
  const stepRef = useRef(step);
  const [event, setEvent] = useState(0);
  const timer = useRef(null);
  const [stepMenu, setStepMenu] = useState([...stepsData(t)]);

  const [modalText, setModalText] = useState(stepsDetail(t)[1]);

  const textDom = useRef(null);
  const deviceWrap = useRef(null);

  useEffect(() => {
    setStepMenu((oldData) => {
      const newData = stepsData(t);
      oldData.forEach((item, index) => {
        newData[index].active = item.active;
      });
      return newData;
    });
  }, [t]);

  const { isLimit } = useAreaLimit();

  if (isLimit) {
    return <DomainLimit />;
  }

  // 监听自动播放
  useMemo(() => {
    autoRef.current = auto;
  }, [auto]);
  // 监听step
  useMemo(() => {
    stepRef.current = step;
  }, [step]);

  const handleChangeAuto = useCallback(() => {
    if (step === 0) {
      // 初始化的时候，仅改变自动播放属性
      setAuto((b) => !b);
      return;
    }
    setAuto((b) => !b);
    if (!auto) {
      // 重新自动播放
      autoplayFn();
    }
  }, [auto, step]);

  const handleSelect = useCallback(
    (index) => {
      if (step === 0) {
        return;
      }
      setAuto(false);

      scaleFn(index + 1, () => {
        setStep(index + 1);
        setStepMenu((menus) => {
          menus.forEach((i) => (i.active = false));
          menus[index].active = true;
          return [...menus];
        });
      });
    },
    [step]
  );

  const autoplayFn = () => {
    if (stepRef.current < 11) {
      clearTimeout(timer.current);
      const _setp = stepRef.current + 1;

      scaleFn(_setp, () => {
        setStep(_setp);
        setStepMenu((menus) => {
          menus.forEach((i) => (i.active = false));
          menus[_setp - 1].active = true;
          return [...menus];
        });
      });

      timer.current = setTimeout(() => {
        if (autoRef.current) {
          autoplayFn();
        }
      }, 6000);
    } else {
      setAuto(false);
    }
  };

  const scaleFn = (_step, fn) => {
    textDom.current.style.opacity = 0;
    setEvent(_step);
    setTimeout(() => {
      textDom.current.style.opacity = 1;
      fn();
    }, 500);
    // eslint-disable-next-line default-case
    let deviceObj = deviceTransformMap[_step];
    let textObj = textTransformMap[_step];
    deviceWrap.current.style.transform = `scale(${deviceObj.scale}) translate(0, ${deviceObj.y}rem)`;
    setTimeout(() => {
      setModalText(stepsDetail(t)[_step]);
      textDom.current.style.left = textObj.l + 'rem';
      textDom.current.style.top = textObj.t + 'rem';
    }, 350);
  };

  // useEffect(() => {
  //   if (step == 0) {
  //     return;
  //   }
  //   setTimeout(() => {
  //     setModalText(stepsDetail(t)[step]);
  //   }, 350);
  // }, [step]);

  useEffect(() => {
    const detail = stepsDetail(t)[step];
    detail && setModalText(detail);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);

  return (
    <BaseContainer>
      <Header />
      <div styleName="how-to-play">
        <div styleName="wrap">
          <div styleName="device" ref={deviceWrap}>
            <div styleName="inner">
              <Device step={step} begin={autoplayFn} event={event} />
            </div>
          </div>
        </div>
        <div styleName="steps">
          <div styleName="autoplay">
            <span className={getSpecFont(i18n.language, false)}>{t('autoplay')}</span>
            <div styleName={auto ? 'switch auto' : 'switch'} onClick={handleChangeAuto}>
              <span></span>
            </div>
          </div>
          {stepMenu.map((item, index) => (
            <div
              styleName={item.active ? 'step-line act-step' : 'step-line'}
              key={index}
              onClick={() => handleSelect(index)}
            >
              <span styleName="words" className={getSpecFont(i18n.language, false)}>
                {item.name.toUpperCase()}
              </span>
              <span styleName="icon"></span>
            </div>
          ))}
        </div>
        <div styleName="tip-pos">
          <div styleName="tip-wrap" ref={textDom}>
            <div styleName="tip-inner">
              <p styleName="tip-tit" className={getSpecFont(i18n.language)}>
                {modalText.title.toUpperCase()}
              </p>
              <p styleName="tip-text" className={getSpecFont(i18n.language, false)}>
                {getSpecLine(modalText.text, i18n.language)}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer customStyle={{ marginTop: '-0.9rem' }} />
    </BaseContainer>
  );
}
